import theme from '../themes/default'

export default {
  'overwrite-navbar': {
    color: theme.txtColor,
    height: '47px',
    '& .am-navbar-left': {
      'padding-left': '0',
      '& > div': {
        height: '47px',
        // 'padding': '10px 0',
        // 'position': 'relative',
        'z-index': '1 !important',
        display: 'flex',
        'align-items': 'center',
        'font-weight': 'bold',
        'font-family': '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',

      },
      '& img': {
        width: '65px',
        'margin-right': '10px',
        '&.takeaway': {
          width: '90px',
        },
      },
    },
    '& .am-navbar-right': {
      position: 'absolute',
      'margin-right': '15px',
      right: '0',
      top: '0',
      height: '47px',
      '& img': {
        width: '30px',
      },
      '& .root': {

      },
      '& .sidebar': {
        background: '#fff',
        'z-index': '999 !important',
        position: 'fixed !important',
      },
      '& .overlay': {
        'z-index': '998 !important',
      },
    },
  },
  'navbar-icon': {
    'z-index': 1,
    marginLeft: 20,
    fontSize: 24,
  },
  'navbar-icons-wrap': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  'qrcode-reader-wrap': {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 9999,
    backgroundColor: '#000000e6',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  'qrcode-reader': {
    width: 300,
    height: 300,
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/NavBar.js